import type { ReactNode } from 'react';

type EvidenceFigureProps = {
  name: string;
  help?: string | readonly string[];
  className?: string;
  children: ReactNode;
};

function EvidenceFigure({ name, help, className, children }: EvidenceFigureProps) {
  return (
    <div
      className={className === undefined ? 'diagnostics-evidence-figure' : `diagnostics-evidence-figure ${className}`}
      role="group"
      aria-label={name}
    >
      <dt className="diagnostics-evidence-figure-name">{name}</dt>
      <dd className="diagnostics-evidence-figure-value">{children}</dd>
      {[help ?? []].flat().map((line) => (
        <dd key={line} className="diagnostics-evidence-figure-help">
          {line}
        </dd>
      ))}
    </div>
  );
}

export default EvidenceFigure;
